import React from "react";

const BrandCategoryHeader = ({ brandName, categoryName }) => {
    return (
        <div className="brand__header-meta">
        <div className="brand__cat-name">
            <h2>
                {brandName} {categoryName}
            </h2>
        </div>
    </div>
    );
}

export default BrandCategoryHeader;
    